import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SitemapPath, useSitemap } from 'shared/hooks/useSitemap.ts';
import { DocumentIcon, GridIcon } from 'shared/icons';
import { IconType } from 'shared/icons/SvgIcon.tsx';
import { MenuItem } from './MenuItem.tsx';

const pathIcons: Record<SitemapPath, IconType> = {
  dashboard: GridIcon,
  jobOrderHistory: DocumentIcon,
};

export const Menu = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'common:navbar',
  });
  const sitemap = useSitemap();

  const menuItems = useMemo(
    () => [
      {
        name: 'dashboard',
        href: sitemap.dashboard,
        activePattern: /^\/[^/]+(\/(?!job-orders-history|archived-job-order).*)?$/,
      },
      {
        name: 'jobOrderHistory',
        href: sitemap.jobOrderHistory,
        activePattern: /.*\/(job-orders-history|archived-job-order(\/.*)?)$/,
      },
    ],
    [sitemap],
  );

  return (
    <nav className="mt-10 sm:mt-14">
      <ul className="space-y-4">
        {menuItems.map(({ name, href, activePattern }) => (
          <MenuItem
            key={name}
            href={href}
            label={t(name)}
            icon={pathIcons[name as SitemapPath]}
            activePattern={activePattern}
          />
        ))}
      </ul>
    </nav>
  );
};
